module.exports = __webpack_public_path__ + "img/num_8.fd7b4d77.png";